import Navbar from "../Navbar/Navbar";
import { useState, useEffect } from "react";
import "./LeaveApply.css";
import { useDispatch, useSelector } from "react-redux";
import { empList } from "../../Redux/DailyUpdateApproval/Action";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { createPassout, getPassOutSummary, getPassOutDetails, bulkApproveOfPassOuts } from "../../Redux/Leave/Action";
import { FaEdit } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import Icon from "../utility/Icon";
import NewDataTable from "../DataTable/NewDataTable";


const Passout = () => {

    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const role = localStorage.getItem("role");
    const currentYear = new Date().getFullYear();
    const { emplists } = useSelector((store) => store.dailyUpdateApprover);
    const { passoutlist, passoutdetails } = useSelector((store) => store.leave)
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [show, setShow] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [checkbox, setCheckbox] = useState(false);
    const [showApprovalInfo, setShowApprovalInfo] = useState(false);
    const [selectedYear, setSelectedYear] = useState({
        value: currentYear,
        label: currentYear.toString(),
    });

    const formatDate = (date) => {
        const d = new Date(date);
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    };

    const [passOutData, setPassOutData] = useState({
        userId: loginId,
        passOutId: "",
        date: formatDate(new Date()),
        remark: "",
        fromTime: "",
        toTime: "",
        durationText: "",
        duration: 0,
        isApproved: "",
        actionType: "INSERT",
    });

    useEffect(() => {
        dispatch(empList(token, "EMP_SUPPORT"));
        if (selectedYear && selectedEmployee) {
            dispatch(getPassOutSummary(token, selectedYear?.value, selectedEmployee?.value));
        }
    }, [dispatch, selectedYear, selectedEmployee, token]);

    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };
    // Generate last 10 years
    const yearOptions = Array.from({ length: 10 }, (_, i) => {
        const year = currentYear - i;
        return { value: year, label: year.toString() };
    });

    const handleChange = (option) => {
        setSelectedYear(option);
    };

    let options = [
        { value: 'All', label: 'All' },
        ...emplists.map((emp) => ({
            value: emp.loginId,
            label: `${emp?.firstName || ""} ${emp?.lastName || ""}`.trim(),
        })),
    ];

    if (role === "ROLE_EMP" || role === "ROLE_SUPPORT") {
        options = options.filter((opt) => opt.value === loginId);
    }

    useEffect(() => {
        if (options.length > 0 && selectedEmployee === null) {
            setSelectedEmployee(options[0]);
        }
    }, [options, selectedEmployee]);


    const handleEmpChange = (selectedOption) => {
        setSelectedEmployee(selectedOption);
    };



    const fetchPassOutDetails = async (e) => {
        dispatch(getPassOutDetails(token, e.passOutId));
        setShow(true);
    }

    const handleApproveLeave = async (e) => {
        let approveData = ({
            userId: loginId,
            passOutId: e.passOutId,
            actionType: "APPROVE",
        });
        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
        });
        if (result.isConfirmed) {

            setIsSubmitting(true);
            dispatch(createPassout(token, approveData))
                .then((response) => {
                    if (response.statusMessage === "SUCCESS") {
                        dispatch(getPassOutSummary(token, selectedYear?.value, 'All'))
                        clearLeaveInputFields();
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.statusDesc,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "There was an error initiating the pass out details.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    }
    useEffect(() => {
        if (role !== "ROLE_ADMIN" && passoutdetails) {
            setPassOutData({
                userId: passoutdetails.loginId,
                passOutId: passoutdetails.passOutId,
                date: passoutdetails.date,
                remark: passoutdetails.remark,
                fromTime: passoutdetails.fromTime,
                toTime: passoutdetails.toTime,
                durationText: "",
                duration: 0,
                isApproved: passoutdetails.isApproved,
                actionType: "UPDATE",

            });
        }

    }, [passoutdetails, passoutlist])

    useEffect(() => {
        const notApproved = passoutlist?.some(
            passout => passout.isApproved === "N"
        );
        setShowApprovalInfo(!notApproved);
    }, [passoutlist]);





    const bulkApprove = () => {

        if (showApprovalInfo) {
            Swal.fire({
                icon: "info",
                title: "Already Approved",
                text: "All the pass outs have been approved for the selected year.",
                timer: 3000,
                showConfirmButton: false
            });
            return;

        }

        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to approve all the pass outs?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, approve",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (!result.isConfirmed) return;

            dispatch(bulkApproveOfPassOuts(loginId, selectedYear?.value, token))
                .then(({ success, error }) => {
                    if (success) {
                        dispatch(getPassOutSummary(token, selectedYear?.value, 'All'))
                        Swal.fire({
                            icon: "success",
                            title: "Success!",
                            text: "All the passouts approved successfully.",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Error!",
                            text: error || "Something went wrong. Please try again later.",
                        });
                    }
                });
        });
    };


    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        ...((role === "ROLE_ADMIN" && selectedEmployee?.value === "All") ?
            [
                {
                    name: "Name",
                    selector: (row, index) => row?.empName || "-",
                    sortable: true,
                    align: "center",
                },
            ]
            : []),
        {
            name: "Pass Out Date",
            selector: (row) => row?.date ?? "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Duration",
            selector: (row) => {
                if (row.duration == null) return "";
                const hours = Math.floor(row.duration / 60);
                const minutes = row.duration % 60;
                if (hours > 0 && minutes > 0) return `${hours} hr${hours > 1 ? "s" : ""} ${minutes} min`;
                if (hours > 0) return `${hours} hr${hours > 1 ? "s" : ""}`;
                return `${minutes} min`;
            },
            sortable: true,
            align: "center",
        },
        {
            name: "Period",
            selector: (row) =>
                row.fromTime && row.toTime ? `${row.fromTime.slice(0, 5)} - ${row.toTime.slice(0, 5)}` : "",
            sortable: false,
            align: "center",
        },
        {
            name: "Remark",
            selector: (row) => row?.remark || "-",
            sortable: true,
            align: "left",
        },
        {
            name: "Action",
            selector: (row) => row,
            sortable: false,
            width: "226px",
            align: "center",
            cell: (row) => (
                <div>
                    {(role === "ROLE_EMP" || role === "ROLE_SUPPORT") && (
                        <div>
                            {row.isApproved === "N" && (
                                <Tooltip text="Edit">
                                    <Icon
                                        icon={FaEdit}
                                        variant="warning"
                                        onClick={() => fetchPassOutDetails(row)}
                                    />
                                </Tooltip>
                            )}
                            {row.isApproved === "Y" && (
                                <span className="text-success fw-bold">Approved</span>
                            )}
                        </div>
                    )}

                    {role === "ROLE_ADMIN" && (
                        <div>
                            {row.isApproved === "N" && (
                                <Tooltip text="Approve">
                                    <button
                                        type="button"
                                        className="btn btn-success btn-sm me-2"
                                        onClick={() => handleApproveLeave(row)}
                                    >
                                        <FaCheck />
                                    </button>
                                </Tooltip>
                            )}
                            {row.isApproved === "Y" && (
                                <span className="text-success fw-bold">Approved</span>
                            )}
                        </div>
                    )}
                </div>
            ),
        },


    ];


    const clearLeaveInputFields = () => {
        setPassOutData({
            userId: loginId,
            passOutId: "",
            date: formatDate(new Date()),
            remark: "",
            fromTime: "09:30",
            toTime: "19:30",
            durationText: "",
            duration: 0,
            isApproved: "",
            actionType: "INSERT",
        });
    };

    const handleClose = () => {
        clearLeaveInputFields();
        setCheckbox(false);
        setShow(false);
    };

    const handleDateChange = (date, name) => {

        if (name === "fromTime" || name === "toTime") {
            setPassOutData((prevData) => ({
                ...prevData,
                [name]: date ? format(date, "HH:mm") : "",
            }));
        } else {
            setPassOutData((prevData) => ({
                ...prevData,
                [name]: date ? format(date, "yyyy-MM-dd") : "",
            }));
        }
    };

    const handlePassoutDataChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value.replace(/^\s+/, "");
        setPassOutData((values) => ({
            ...values,
            [name]: trimmedValue,
        }));
    };


    const handleapply = () => {
        setPassOutData({
            userId: loginId,
            passOutId: "",
            date: formatDate(new Date()),
            remark: "",
            fromTime: "",
            toTime: "",
            durationText: "",
            duration: 0,
            isApproved: "",
            actionType: "INSERT",
        })
        setShow(true)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const result = await Swal.fire({
            title: "Are you sure?",
            icon: "warning",

            html: `
                    <div class="d-flex align-items-center mt-3">
                        <input type="checkbox" id="hrConfirm" class="me-2" />
                        <label for="hrConfirm" class="mb-0" style="cursor:pointer;">
                        <strong>
                            I confirm that HR/Manager approval has been obtained.
                        </strong>
                        </label>
                    </div>
                    `,


            showCancelButton: true,
            confirmButtonText: "Yes, submit it!",
            cancelButtonText: "No, cancel",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",

            didOpen: () => {
                const checkbox = document.getElementById("hrConfirm");
                checkbox.addEventListener("change", () => {
                    Swal.resetValidationMessage(); // ✅ clear error immediately
                });
            },

            preConfirm: () => {
                const checkbox = document.getElementById("hrConfirm");
                if (!checkbox.checked) {
                    Swal.showValidationMessage(
                        "Please confirm HR/Manager approval before submitting."
                    );
                    return false;
                }
                return true;
            }
        });



        if (result.isConfirmed) {

            setIsSubmitting(true);
            dispatch(createPassout(token, passOutData))
                .then((response) => {
                    if (response.statusMessage === "SUCCESS") {
                        dispatch(getPassOutSummary(token, selectedYear?.value, loginId))
                        setShow(false);
                        setCheckbox(false);
                        clearLeaveInputFields();
                        Swal.fire({
                            title: "Success!",
                            text: response.statusDesc,
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.statusDesc,
                            icon: "error",
                            confirmButtonText: "OK",
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: "Error!",
                        text: "There was an error initiating the pass out details.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    }

    useEffect(() => {
        if (passOutData.fromTime && passOutData.toTime) {
            const start = new Date(`1970-01-01T${passOutData.fromTime}`);
            const end = new Date(`1970-01-01T${passOutData.toTime}`);

            let diff = (end - start) / 1000 / 60; // difference in minutes
            if (diff < 0) diff += 24 * 60; // handles overnight times

            const hours = Math.floor(diff / 60);
            const minutes = diff % 60;

            const durationStr =
                hours > 0
                    ? `${hours} hr${hours > 1 ? "s" : ""} ${minutes > 0 ? `${minutes} min` : ""}`
                    : `${minutes} min`;

            setPassOutData((prev) => ({
                ...prev,
                durationText: durationStr,
                duration: Math.round(diff),
            }));
        } else {
            setPassOutData((prev) => ({
                ...prev,
                durationText: "",
                duration: 0,
            }));
        }
    }, [passOutData.fromTime, passOutData.toTime, passOutData.durationText]);



    return (
        <div>
            <Navbar></Navbar>
            <div className="main-content">
                <div className="container-fluid mt-4">

                    <div className="card3">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0  left-header"></h5>

                                <div className="filter-container">
                                    <div className="row g-3 justify-content-md-end">

                                        {/* Year */}
                                        <div className="col-12 col-md-auto d-flex align-items-center filter-item">
                                            <b><label className="me-2 mb-0 custom-label">Year:</label></b>
                                            <div className="filter-select">
                                                <Select
                                                    options={yearOptions}
                                                    value={selectedYear}
                                                    onChange={handleChange}
                                                    placeholder="Select Year"
                                                />
                                            </div>
                                        </div>

                                        {/* Employee */}
                                        <div className="col-12 col-md-auto d-flex align-items-center filter-item">
                                            <b><label className="me-2 mb-0 custom-label">Employee:</label></b>
                                            <div className="filter-select filter-emp">
                                                <Select
                                                    options={options}
                                                    value={selectedEmployee}
                                                    onChange={handleEmpChange}
                                                    placeholder="Select Employee"
                                                    isClearable
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                            <>

                                <NewDataTable
                                    columns={columns}
                                    data={passoutlist || []}
                                    tableName="PASS OUT"
                                    totalRecord={passoutlist?.length}
                                />

                                {(role === "ROLE_ADMIN") && passoutlist.length > 0 &&
                                    <div className="text-center">
                                        <button type="button" onClick={bulkApprove} className="btn btn-success mt-3">
                                            APPROVE ALL
                                        </button>
                                    </div>
                                }

                            </>
                            {(role === "ROLE_EMP" || role === "ROLE_SUPPORT") && (<div className="text-center">
                                <button
                                    type="button"
                                    className="btn btn-primary fw-bold mt-3"
                                    onClick={handleapply}
                                >
                                    APPLY PASSOUT
                                </button>
                            </div>
                            )}

                        </div>
                    </div>
                    <div
                        className={`modal leave-modal ${show ? "d-block" : "d-none"}`}
                        tabIndex="-1"
                        style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                    >
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PASS OUT APPLICATION</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleClose}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row mb-3">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="date" className="form-label mb-0">
                                                        Date<span className="text-danger">*</span>
                                                    </label>
                                                    <DatePicker
                                                        selected={passOutData.date ? new Date(passOutData.date) : new Date()}
                                                        onChange={(date) => handleDateChange(date, "date")}
                                                        className="form-control"
                                                        dateFormat="dd-MM-yyyy"
                                                        placeholderText="Date"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        dropdownMode="select"
                                                        minDate={new Date()}
                                                        onKeyDown={(event) => event.preventDefault()}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="fromTime">
                                                        <b>From</b><span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="time"
                                                        id="fromTime"
                                                        className="form-control"
                                                        name="fromTime"
                                                        value={passOutData.fromTime}
                                                        onChange={(e) => {
                                                            handlePassoutDataChange(e);
                                                            e.target.blur();
                                                        }}
                                                        required
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="toTime">
                                                        <b>To</b><span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="time"
                                                        id="toTime"
                                                        className="form-control"
                                                        name="toTime"
                                                        value={passOutData.toTime}
                                                        onChange={(e) => {
                                                            handlePassoutDataChange(e);
                                                            e.target.blur();
                                                        }}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="durationText"><b>Duration</b></label>
                                                    <input
                                                        type="text"
                                                        id="durationText"
                                                        className="form-control bg-light fw-semibold"
                                                        name="durationText"
                                                        value={passOutData.durationText}
                                                        readOnly
                                                    // placeholder="Auto calculated"
                                                    />
                                                </div>
                                            </div>
                                            <div className="mb-3" >
                                                <div className="col-md-12">
                                                    <label htmlFor="remark">
                                                        <b>Reason</b><span className="text-danger">*</span>
                                                    </label>
                                                    <textarea
                                                        type="text"
                                                        id="remark"
                                                        className="form-control"
                                                        name="remark"
                                                        rows={3}
                                                        value={passOutData.remark}
                                                        onChange={handlePassoutDataChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className="col-md-12 d-flex align-items-center">
                                                <label
                                                    htmlFor="checkbox"
                                                    className="d-flex align-items-center"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="checkbox"
                                                        className="me-2"
                                                        name="checkbox"
                                                        checked={checkbox}
                                                        onChange={(e) => setCheckbox(e.target.checked)}
                                                    />
                                                    <span className="fw-bold">
                                                        I agree that HR/Manager approval has been obtained for the pass-out.
                                                    </span>
                                                </label>

                                            </div> */}


                                        </div>
                                        <hr />
                                        <em className="text-danger cs-pass-note">
                                            Note: Please apply for pass-out at least 4 hours in advance. Pass-out without HR/Manager approval is not valid.
                                        </em>

                                        <div className="text-center mt-3">
                                            {passOutData.actionType === "INSERT" ? (
                                                <button type="submit" className="btn btn-success" disabled={isSubmitting}>
                                                    {isSubmitting ? "Submitting..." : "SUBMIT"}
                                                </button>
                                            ) : (
                                                <button type="submit" className="btn btn-warning" disabled={isSubmitting}>
                                                    {isSubmitting ? "Updating..." : "UPDATE"}
                                                </button>
                                            )}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Passout;